import { Routes } from '@angular/router';

import { CamMainRoute, CamRoutes } from '@camelot/menu';
import { AuthGuard, FeatureGuard, LoginRedirectComponent } from '@camelot/user';

import { RedirectPage } from './features/base/redirect/redirect.component';
import { ECallbackRoute, callbackRoutes } from './features/callback/callback.routes';
import { EContactsRoute, contactsRoutes } from './features/contacts/contacts.routes';
import { EFinancialsRoute, financialsRoutes } from './features/financials/financials.routes';
import { EItemsRoute, itemsRoutes } from './features/items/items.routes';
import { EPlanningsRoute, planningsRoutes } from './features/plannings/plannings.routes';
import { EProjectsRoute, projectsRoutes } from './features/project/projects.routes';
import { EPurchasesRoute, purchasesRoutes } from './features/purchases/purchases.routes';
import { ESalesRoute, salesRoutes } from './features/sales/sales.routes';
import { ESettingsRoute, settingsRoutes } from './features/settings/settings.routes';
import { ETasksRoute, tasksRoutes } from './features/tasks/tasks.routes';
import { EUserRoute, userRoutes } from './features/user/user.routes';
import { EValidationsRoute, validationsRoutes } from './features/validations/validations.routes';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/dashboard/pages/dashboard/dashboard.component').then(c => c.DashboardPage),
    canActivate: [AuthGuard],
    pathMatch: 'full',
  },
  {
    path: CamRoutes.getUrl([CamMainRoute.REDIRECT]),
    component: RedirectPage,
  },
  {
    path: CamRoutes.getUrl([CamMainRoute.NOTIFICATIONS]),
    loadComponent: () => import('./features/base/notifications/notifications.component').then(c => c.NotificationsPage),
    canActivate: [AuthGuard],
  },
  {
    path: CamRoutes.getUrl([CamMainRoute.USERLOGIN]),
    component: LoginRedirectComponent,
  },
  {
    canActivate: [AuthGuard, FeatureGuard],
    children: tasksRoutes,
    data: { feature: 'ticketing', level: 'authorize', permissions: ['read:task'] },
    path: CamRoutes.getUrl([ETasksRoute.tasks]),
  },
  {
    canActivate: [AuthGuard, FeatureGuard],
    children: itemsRoutes,
    data: { permissions: ['read:article'] },
    path: CamRoutes.getUrl([EItemsRoute.items]),
  },
  {
    path: CamRoutes.getUrl([EPlanningsRoute.plannings]),
    children: planningsRoutes,
    canActivate: [AuthGuard],
  },
  {
    path: CamRoutes.getUrl([ESettingsRoute.settings]),
    children: settingsRoutes,
    canActivate: [AuthGuard],
  },
  {
    path: CamRoutes.getUrl([EUserRoute.users]),
    children: userRoutes,
    canActivate: [AuthGuard],
  },
  {
    canActivate: [AuthGuard, FeatureGuard],
    children: financialsRoutes,
    data: { feature: 'financial', level: 'authorize', permissions: ['read:invoice'] },
    path: CamRoutes.getUrl([EFinancialsRoute.invoices]),
  },
  {
    canActivate: [AuthGuard, FeatureGuard],
    children: salesRoutes,
    data: { feature: 'sales', level: 'authorize', permissions: ['read:quotation'] },
    path: CamRoutes.getUrl([ESalesRoute.sales]),
  },
  {
    path: CamRoutes.getUrl([EPurchasesRoute.purchases]),
    children: purchasesRoutes,
    canActivate: [AuthGuard],
  },
  {
    canActivate: [AuthGuard, FeatureGuard],
    children: contactsRoutes,
    data: { permissions: ['read:contact'] },
    path: CamRoutes.getUrl([EContactsRoute.contacts]),
  },
  {
    canActivate: [AuthGuard, FeatureGuard],
    children: projectsRoutes,
    data: { permissions: ['read:project'] },
    path: CamRoutes.getUrl([EProjectsRoute.projects]),
  },
  {
    canActivate: [AuthGuard, FeatureGuard],
    children: validationsRoutes,
    data: { feature: 'validation', level: 'authorize', permissions: ['read:validation'] },
    path: CamRoutes.getUrl([EValidationsRoute.validations]),
  },
  {
    path: CamRoutes.getUrl([ECallbackRoute.callback]),
    children: callbackRoutes,
  },
  {
    path: '**',
    loadComponent: () => import('./features/base/not-found/not-found.component').then(c => c.NotFoundPage),
  },
];
